export * from './lib/task-data-access.module';
export * as TaskActions from './lib/+state/task.actions';
export * as TaskSelectors from './lib/+state/task.selectors';
export { TaskService }from './lib/+state/task.service';